// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileInput_wrapper__Vqdij","registeredInput":"ProfileInput_registeredInput__wdW8d","label":"ProfileInput_label__B6stE"};